import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {
    OrganizationEenCustomerAccountComponent,
} from '../edit-organization/organization-een-customer-account/organization-een-customer-account.component';
import {OrganizationOnboardingComponent} from '../../shared/organization-onboarding/organization-onboarding.component';
import {OrganizationDetailContext} from './organization-detail.context';

@Component({
    selector: 'app-organization-operational-readiness-page',
    standalone: true,
    imports: [CommonModule, OrganizationOnboardingComponent, OrganizationEenCustomerAccountComponent],
    template: `
        <section data-testid="organization-operational-readiness-page">
            <app-organization-een-customer-account
                [organizationId]="organizationId"
                [organizationName]="organizationName"
                [hidePanelHeading]="false"
                [readOnly]="true">
            </app-organization-een-customer-account>
            <app-organization-onboarding
                [organizationId]="organizationId"
                [organizationActive]="organizationActive"
                [hidePanelHeading]="true">
            </app-organization-onboarding>
        </section>
    `,
})
export class OrganizationOperationalReadinessPageComponent implements OnInit, OnDestroy {
    organizationId: number | null = null;
    organizationActive: boolean | null = null;
    organizationName: string | null = null;
    private subs = new Subscription();

    constructor(
        private route: ActivatedRoute,
        private organizationContext: OrganizationDetailContext,
    ) {
    }

    ngOnInit(): void {
        this.subs.add(
            this.route.parent!.paramMap.subscribe((params) => {
                const raw = params.get('organizationId');
                const id = raw ? Number(raw) : NaN;
                this.organizationId = Number.isFinite(id) ? id : null;
            }),
        );
        this.subs.add(
            this.organizationContext.organization$.subscribe((org) => {
                this.organizationActive = org?.is_active ?? null;
                this.organizationName = org?.name ?? null;
            }),
        );
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
